import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  assessment: {},
  learningSpaces: []
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/assessment/vuex/index.js